module.exports = __webpack_public_path__ + "img/nav11.dc25c9fd.png";